import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export enum eTransportationOptions {
  BUS = 'bus',
  TRAIN = 'train',
  LIGHT_TRAIN = 'lightRail',
  CARMELIT = 'carmelit',
  RAHBALIT = 'rahbalit',
  PUBLIC_TAXI = 'publicTaxi'
}

export enum eTransportationOptionsHerbrew {
  BUS = 'אוטובוס',
  TRAIN = 'רכבת',
  LIGHT_TRAIN = 'רכבת קלה',
  CARMELIT = 'כרמלית',
  RAHBALIT = 'רכבלית',
}

export const TRANSPORTATION_OPTIONS: SelectOption<eTransportationOptions>[] = [
  {
    label: 'אוטובוס',
    value: eTransportationOptions.BUS,
    icon: 'bus',
  },
  {
    label: 'רכבת',
    value: eTransportationOptions.TRAIN,
    icon: 'train',
  },
  {
    label: 'רכבת קלה',
    value: eTransportationOptions.LIGHT_TRAIN,
    icon: 'bus',
  },
  {
    label: 'כרמלית',
    value: eTransportationOptions.CARMELIT,
    icon: 'bus',
  },
  {
    label: 'רכבלית',
    value: eTransportationOptions.RAHBALIT,
    icon: 'bus',
  },
  {
    label: 'מונית שירות',
    value: eTransportationOptions.PUBLIC_TAXI,
    icon: 'bus',
  },
];
